export enum POSAutoCutterStatus {
    OK = "OK",
    ERROR = "ERROR",
    UNKNOWN = "UNKNOWN",
}
